import { render, staticRenderFns } from "./Chart_Admin.vue?vue&type=template&id=72d98a30&scoped=true"
import script from "./Chart_Admin.vue?vue&type=script&lang=js"
export * from "./Chart_Admin.vue?vue&type=script&lang=js"
import style0 from "./Chart_Admin.vue?vue&type=style&index=0&id=72d98a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d98a30",
  null
  
)

export default component.exports